<template>
    <div class="routing-addresses-loading">
        <Card v-for="cardIndex in CARD_COUNT" :key="cardIndex" :size="CardSize.MEDIUM">
            <div class="routing-addresses-loading__inner">
                <CompassSkeleton
                    class="routing-addresses-loading__header"
                    :variant="CompassEnums.SkeletonVariantType.LINE"
                    :size="CompassEnums.SkeletonSize.LARGE"
                />
                <CompassSkeleton
                    class="routing-addresses-loading__footer"
                    :variant="CompassEnums.SkeletonVariantType.LINE"
                    :size="CompassEnums.SkeletonSize.MEDIUM"
                />
            </div>
        </Card>
    </div>
</template>

<script setup lang="ts">
import Card from 'vcomponents/common/card/Card.vue';
import { CardSize } from 'types/components/common/Card.type';

const CARD_COUNT = 2;
</script>

<style lang="scss" scoped>
.routing-addresses-loading {
    margin-top: var(--spacing-1);
    &__inner {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-1);
    }
    &__header {
        width: 60%;
    }
    &__footer {
        width: 30%;
    }
}
</style>
